import React, { useState } from "react";
import { Loader2 } from "lucide-react";
import { cn } from "@/lib/utils";

const LOADING_PAGE_URL = "https://loading-page.optidev.ai/";

interface LoadingSpinnerProps {
    message: string;
    color?: string;
    bgColor?: string;
    /** Show the onboarding slideshow instead of spinner */
    showSlideshow?: boolean;
}

export const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({
    message,
    color = "text-primary",
    bgColor = "bg-background",
    showSlideshow = false,
}) => {
    const [iframeError, setIframeError] = useState(false);

    // Show slideshow iframe if requested and hasn't errored
    if (showSlideshow && !iframeError) {
        return (
            <div
                className={cn(
                    "absolute inset-0 z-20",
                    bgColor
                )}>
                <iframe
                    src={LOADING_PAGE_URL}
                    className="w-full h-full border-0"
                    title="Loading"
                    onError={() => setIframeError(true)}
                    sandbox="allow-scripts"
                />
            </div>
        );
    }

    // Fallback to spinner
    return (
        <div
            className={cn(
                "absolute inset-0 flex items-center justify-center z-20",
                bgColor
            )}>
            <div className="text-center">
                <Loader2
                    className={cn("w-8 h-8 animate-spin mx-auto mb-2", color)}
                />
                <p className="text-sm text-muted-foreground">{message}</p>
            </div>
        </div>
    );
};
